import React from 'react';
import { remote, remoteEither } from '@code-expert/prelude';
export const useStaleWhileRevalidate = (rd) => {
    const rrd = React.useRef(rd);
    rrd.current = remote.staleWhileRevalidate(rd)(rrd.current);
    return rrd.current;
};
export const useStaleWhileRevalidateEither = (rd) => {
    const rrd = React.useRef(rd);
    rrd.current = remoteEither.staleWhileRevalidate(rd)(rrd.current);
    return rrd.current;
};
//# sourceMappingURL=useStaleWhileRevalidate.js.map